// extracted by mini-css-extract-plugin
export default {"button":"ButtonRed_button__wwrp5"};